(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hardware-specs"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initSection(root) {
    if (!root || root.dataset._inited === '1') return;
    root.dataset._inited = '1';

    const speed   = parseInt(root.dataset.speed || '1500', 10);
    const trigger = (root.dataset.trigger || 'scroll').toLowerCase();

    const counters = Array.from(root.querySelectorAll('.hw-specs__count'));
    if (!counters.length) return;

    // Prime numbers to 0 so the animation is visible
    counters.forEach(el => {
      const raw = (el.dataset.count || '').replace(/[, ]/g,'').trim();
      if (!raw) return;
      el.dataset._target = raw;
      const decimals = raw.includes('.') ? (raw.split('.')[1] || '').length : 0;
      el.textContent = decimals ? ('0.' + '0'.repeat(decimals)) : '0';
      el.dataset._animating = '0';
    });

    const animate = (el) => {
      if (el.dataset._animating === '1') return;
      el.dataset._animating = '1';

      const raw = el.dataset._target;
      const target = parseFloat(raw);
      if (isNaN(target)) { el.dataset._animating = '0'; return; }

      const decimals = raw.includes('.') ? (raw.split('.')[1] || '').length : 0;
      const startTime = performance.now();

      const step = (now) => {
        const p = Math.min((now - startTime) / speed, 1);
        const val = target * p;
        el.textContent = decimals ? val.toFixed(decimals) : Math.floor(val).toLocaleString();
        if (p < 1) requestAnimationFrame(step);
        else el.dataset._animating = '0';
      };

      requestAnimationFrame(step);
    };

    // Mode: animate immediately
    if (trigger === 'load') {
      counters.forEach(animate);
      return;
    }

    // Mode: animate when visible
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animate(entry.target);
            io.unobserve(entry.target); // remove this line if you want replay
          }
        });
      }, { root: null, rootMargin: '0px 0px -15% 0px', threshold: 0.25 });

      counters.forEach(el => io.observe(el));
    } else {
      // Fallback (older browsers)
      const inView = (el) => {
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        return r.top < vh * 0.9 && r.bottom > 0;
      };
      const checkAll = () => counters.forEach(el => { if (inView(el)) animate(el); });
      window.addEventListener('scroll', checkAll, { passive: true });
      window.addEventListener('resize', checkAll);
      checkAll();
    }
  }

  function initAll() {
    document.querySelectorAll('.hw-specs').forEach(initSection);
  }

  // Run now
  initAll();

  // Re-run when Shopify hot-reloads a section in the editor
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
